import React ,{ useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from "react-redux";
import {Box, Grid, Typography, Table, TableBody, TableCell, TableHead,TableRow, Paper, Divider, TableContainer,Button, Stack } from '@mui/material';
import dayjs from 'dayjs';
import image from "../../../asserts/logo logistic.png"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router"; 
import Inscanpdf from "../../../components/Custom/Inscanpdf"
import moment from 'moment';
import {fetchAndOpenPdf} from "../../../redux/Thunk/officeManifestThunk"

const InscanFormat = () => {
  const location = useLocation();
    const dispatch = useDispatch();
  const { docketData } = location.state;
  const { state } = useLocation();
  const navigate = useNavigate();
  const { ManifestId, ModeType,ToStationId, OriginId, PickupDetails = [], LoadingPerson,Docket,UnLoadingPersion} = docketData || {};
  const totalPkgs = PickupDetails.reduce((acc, cur) => acc + (cur.totalPkg || 0), 0);
  const totalWeight = PickupDetails.reduce((acc, cur) => acc + (cur.totalVolumetrix || 0), 0).toFixed(3);
const awbDate = docketData?.Docket?.map(d =>
  d?.createdAt ? moment(d.createdAt).format("DD-MM-YYYY HH:mm") : "-"
)?.join(", ") || "-";


  const createdDate = dayjs(docketData?.createdAt).format('DD-MM-YYYY'); // "17-06-2025"
  const createdTime = dayjs(docketData?.createdAt).format('HH:mm');    
  const docketIds = PickupDetails.map(p => p.DocketId).join(', ');
  let modeName = "N/A";
   if (ModeType === "AIR") {
    modeName = docketData?.AirDetails?.[0]?.Flight || "N/A";
   } else if (ModeType === "ROAD") {
    modeName = docketData?.RoadDetails?.[0]?.VehicalType || "N/A";
   } else if (ModeType === "TRAIN") {
    modeName = docketData?.TrainDetails?.[0]?.VehicalType || "N/A";
   }
    // const inscanRef = useRef();
    //   const handleDownloadClick = () => {
    //   inscanRef.current?.generatePDF(); // Call method from child
    // };
      const handleDownloadClick = () => {
    dispatch(fetchAndOpenPdf(ManifestId));
  };
  return (
    <>
    <Paper sx={{ p: 4, m: 3 }}>     
      <Box className="custom-data-grid-container_table"> 
        <Stack direction={'row'} spacing={1} justifyContent={"flex-end"} alignItems={'center'}>
        <Button sx={{justifyContent:'flex-end'}} variant="contained" color="success" onClick={handleDownloadClick}>Download PDF</Button></Stack>
       <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ mr: 2 }}> <ArrowBackIcon onClick={() => navigate("/dashboard/viewlist")}/></Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, justifyContent: 'center' }}>
        <img src={image} alt='' style={{ height: 40 }} />
        <Typography variant="h6" sx={{ textAlign: 'center' }}>LA LOGISTICS PRIVATE LIMITED </Typography>
       </Box>
      </Box>
     <Typography align="center" sx={{ mb: 2 }}>{OriginId?.toUpperCase()} - {ToStationId?.toUpperCase()} </Typography>
    
    
        {/* Updated Manifest Info */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {/* Left */}
          <Grid  size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
            <Typography><b>Manifest:</b> {ManifestId}</Typography>
            <Typography><b>Dispatch From:</b> {OriginId}</Typography>
            <Typography><b>Mode Type:</b> {ModeType}</Typography>
            <Typography><b>Master AWB Date:</b> {awbDate}</Typography>
            {/* <Typography><b>Vendor:</b> INTERGLOBE AVIATION LIMITED</Typography> */}
            <Typography><b>Master AWB Weight:</b> {totalWeight}</Typography>
          </Grid>

          {/* Right */}
          <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
            <Typography><b>Manifest Date:</b> {createdDate}</Typography>
            <Typography><b>Time:</b> {createdTime}</Typography>
            <Typography><b>Dispatch To:</b> {ToStationId}</Typography>
            <Typography><b>Mode Name:</b> {modeName}</Typography>
            <Typography><b>Master AWB:</b> {docketIds}</Typography>
            <Typography><b>Master AWB Pckgs:</b> {totalPkgs}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 2 }} />
        <Typography variant="subtitle1"><b>Docket Details:</b></Typography>

        <TableContainer component={Paper} sx={{ mb: 3 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>No.</TableCell>
                <TableCell>Docket ID</TableCell>
                <TableCell>Origin</TableCell>
                <TableCell>Destination</TableCell>
                <TableCell>Consignee</TableCell>
                <TableCell>Consignor</TableCell>
                <TableCell>Packages</TableCell>
                <TableCell>Weight</TableCell>
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {PickupDetails.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.DocketId}</TableCell>
                  <TableCell>{item.Origin}</TableCell>
                  <TableCell>{item.Destination}</TableCell>
                  <TableCell>{item.Consigner}</TableCell>
                  <TableCell>{item.Consignee}</TableCell>
                  <TableCell>{item.totalPkg}</TableCell>
                  <TableCell>{item.totalVolumetrix}</TableCell>
                  <TableCell>{item.Remark}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={6}><b>Total</b></TableCell>
                <TableCell><b>{totalPkgs}</b></TableCell>
                <TableCell><b>{totalWeight}</b></TableCell>
                <TableCell />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Divider sx={{ my: 3 }} />

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography><b>Prepared By:</b> {LoadingPerson || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><b>Dispatch Manager:</b>{UnLoadingPersion || 'N/A'}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
    {/* <Inscanpdf ref={inscanRef} state={state?.docketData}/> */}
    </>
  );
};

export default InscanFormat;
